import { useTranslation } from "react-i18next";

// بطاقة حالة العمل عن بُعد: فعّالة الآن، أو قيد السريان اعتباراً من الغد.
export const RemoteStatusCard = ({ active, since, absentToday }) => {
  const { t } = useTranslation();
  if (active) {
    return (
      <div className="rounded-2xl border border-primary/30 bg-primary/5 px-4 py-4 shadow-neu-sm" data-testid="remote-work-card">
        <p className="text-sm font-black text-primary">{t("employees.remoteTitle")}</p>
        <p className="mt-1 text-xs text-muted-foreground">{t("employees.remoteHint")}</p>
      </div>
    );
  }
  return (
    <div className="rounded-2xl border border-amber-500/40 bg-amber-500/5 px-4 py-4 shadow-neu-sm" data-testid="remote-pending-card">
      <p className="text-sm font-black text-amber-600">
        {t(absentToday ? "employees.remotePendingTitle" : "employees.remoteStartsTomorrow")}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">{t("employees.remotePendingHint", { date: since })}</p>
    </div>
  );
};
